module.exports = __webpack_public_path__ + "img/Piso.e959ce78.svg";